import React, { useState } from "react";
import pClasses from "../ListUsersAndAdmins.module.scss";
import FriendlyInfo from "../../FriendlyInfo";
import Button from '@mui/material/Button';
import InputText from "../../Inputs/InputText";
import { UserAdmin } from "../../../interfaces/UserAdmin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as fa from "@fortawesome/free-solid-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import * as h from "../../../helpers";
import * as api from "../../../constants/api";
import { useTranslation } from "react-i18next";
import RoundButton from "../../Buttons/RoundButton";
import useFetch from "../../../hooks/useFetch";
import Spinner from "../../Spinner";
import { isSameText } from "../../../helpers";


import awsConfig from "../../../aws-exports";
import { CognitoIdentityServiceProvider } from 'aws-sdk';
interface Interface {
  admins?: Array<UserAdmin> | null;
  className?: string;
  mySub?: string;
  companyUid?: string | null;
  hideFilter?: boolean;
  showToggleStatus?: boolean;
  showTogglePermissions?: boolean;
  // showCompany_uid?: boolean;
  amIManager: boolean | null | undefined;
}

export default function ListAdmins({
  className = "",
  mySub = "",
  admins = null,
  companyUid = null,
  hideFilter = false,
  // showCompany_uid = true,
  showToggleStatus = false,
  showTogglePermissions = false,
  amIManager = false,
}: Interface) {
  const { t } = useTranslation();

  // const [filterUpdater, setFilterUpdater] = useState("");
  const [filterID, setFilterID] = useState("");
  const [sortActive, setSortActive] = useState(null as boolean | null);
  const [sortIdUser, setSortIdUser] = useState(true as boolean | null);
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [toHide, setHiddenInfo] = useState(false);
  const [confirmToggle, setConfirmToggle] = useState<string | null>(null);
  const [lastEmailSend, setLastEmailSend] = useState<string[]>([]);
  const [errorResentPswd, setErrorResentPswd] = useState<string[]>([]);
  const [lastEmailResent, setLastEmailResent] = useState<string>('');

  const [updatedAdmins, isFetching, hasError, fetchToggle]: any = useFetch({
    // TODO show img error upload
    autoInit: false,
  });

  const [, isLoading, hasErrorResentEmail, fetchResentEmail]: any = useFetch({
    // TODO show img error upload
    autoInit: false,
  });

  // const cognitoIdentityServiceProvider = new CognitoIdentityServiceProvider(
  //   { region: awsConfig.region }
  // )
  let _filtersArea = null;
  // let _labelIdCompany = null;
  let _filtersContent = null;
  let finalUserList = [] as Array<any>;

  const setToggleUserPermissionHandler = (proAdmin: UserAdmin) => {
    let toggleTo = "True";
    if (h.isSameText(proAdmin.is_manager, toggleTo)) toggleTo = "False";

    fetchToggle({
      method: "POST",
      url: api.API_PRO_PERMISSIONS,
      data: {
        professional_sub: proAdmin.sub,
        is_manager: toggleTo,
      },
      onSuccess: () => {
        setConfirmToggle(null);
      },
    });
  };

  const setToggleUserStatusHandler = (proAdmin: UserAdmin) => {
    let toggleTo = "enable";
    if (h.isTrueFromPythonBoolean(proAdmin.active)) toggleTo = "disable";
    fetchToggle({
      method: "POST",
      url: api.API_PRO_ENABLE_DISABLE,
      data: {
        professional_sub: proAdmin.sub,
        action: toggleTo,
      },
      onSuccess: () => {
        setConfirmToggle(null);
      },
    });
  };

  const resentPassword = (email: string) => {
    const dataResentPassword = {
      cognito_pool: 'aws_user_pools_id' in awsConfig ? awsConfig.aws_user_pools_id : null,
      user_sub: email,
    }
    setLastEmailResent(email)
    fetchResentEmail({
      url: api.API_PRO,
      method: "PUT",
      data: dataResentPassword,
      onSuccess: () => {
        setLastEmailSend([...lastEmailSend, email]);
      },
      onError: () => {
        setErrorResentPswd([...errorResentPswd, email])
      },
    });

  }

  const getArrows = (sort: boolean | null) => {
    return (
      <span>
        <FontAwesomeIcon
          className={sort === false ? pClasses.On : pClasses.Off}
          icon={fa.faSortUp}
        />
        <FontAwesomeIcon
          className={sort === true ? pClasses.On : pClasses.Off}
          icon={fa.faSortDown}
        />
      </span>
    );
  };

  const getToggleIconHandler = (
    proAdmin: UserAdmin,
    isMyUser: boolean,
    isStartOpt: boolean,
    showConfirm: boolean,
    setConfirmToggle: (v: string | null) => void,
    kindToConfirm: string,
    confirmFunc: () => void,
    iconFrom: fa.IconDefinition,
    iconTo: fa.IconDefinition,
    labelOn: string,
    labelOff: string,
    showMyUser = false
  ) => {
    let iconStatusFrom = iconFrom;
    let iconStatusTo = iconTo;
    let msgToToggleUserStatus =
      t("global.confirm_toggle_status_to") + " " + t(labelOff);
    let confirmMsgToToggleUserStatus =
      t("global.toggle_status_to") + " " + t(labelOff);
    if (isStartOpt) {
      iconStatusFrom = iconTo;
      iconStatusTo = iconFrom;
      msgToToggleUserStatus =
        t("global.confirm_toggle_status_to") + " " + t(labelOn);
      confirmMsgToToggleUserStatus =
        t("global.toggle_status_to") + " " + t(labelOn);
    }
    const toggleOnClickConfirm = showConfirm
      ? () => setConfirmToggle(null)
      : () => setConfirmToggle(kindToConfirm + proAdmin.sub);

    // Button to toggle
    let _toggleIcons = (
      <RoundButton
        title={confirmMsgToToggleUserStatus}
        aLink
        disabled={isFetching}
        faIcon={iconStatusFrom}
        onClick={toggleOnClickConfirm}
      />
    );

    if (amIManager && isMyUser) {
      _toggleIcons = (
        <p>
          {showMyUser && t("global.my_user")}
          <span className={pClasses.Icon}>
            {" ("}
            <FontAwesomeIcon icon={iconStatusFrom} />
            {")"}
          </span>
        </p>
      );
    } else if (!amIManager) {
      // JUST A ICON -- NOT ADMIN
      _toggleIcons = (
        <span className={pClasses.Icon}>
          <FontAwesomeIcon icon={iconStatusFrom} />
        </span>
      );
    } else if (showConfirm) {
      if (isFetching) {
        _toggleIcons = <Spinner className={pClasses.IconSpinner} extraSmall />;
      } else if (hasError) {
        const { message } = hasError.data ?? hasError;
        let message_error = t("infos.error_saving");
        if (message) message_error = t("api_errors." + message);
        _toggleIcons = (
          <div className={pClasses.VertCenter}>
            <span className={pClasses.InfoIcons}>
              <FontAwesomeIcon icon={fa.faExclamationTriangle} />
            </span>
            <em>{t(message_error)}</em>
            <RoundButton
              title={t("global.cancel")}
              onClick={() => setConfirmToggle(null)}
              aLink
              faIcon={fa.faTimes}
            />
          </div>
        );
      } else {
        // Confirm to toggle
        _toggleIcons = (
          <div className={pClasses.VertCenter}>
            <span className={pClasses.InfoIcons}>
              {"("}
              <FontAwesomeIcon icon={iconStatusFrom} />
              <FontAwesomeIcon icon={fa.faArrowRight} />
              <FontAwesomeIcon icon={iconStatusTo} />
              {")"}
            </span>
            <RoundButton
              title={t("global.cancel")}
              onClick={() => setConfirmToggle(null)}
              aLink
              faIcon={fa.faTimes}
            />
            <RoundButton
              title={msgToToggleUserStatus}
              aLink
              faIcon={fa.faCheck}
              onClick={confirmFunc}
            />
          </div>
        );
      }
    }
    return _toggleIcons;
  };

  const getTableBody = (list: any) => {
    return list.map((proAdmin: UserAdmin, index: number) => {
      const isUnlock = h.isTrueFromPythonBoolean(proAdmin.active);
      const isManager = h.isTrueFromPythonBoolean(proAdmin.is_manager);
      const isMyUser = h.isSameText(proAdmin.sub, mySub);
      const showConfirmStatus = isSameText(
        confirmToggle ?? "",
        "status_" + proAdmin.sub
      );

      const showConfirmPermission = isSameText(
        confirmToggle ?? "",
        "permission_" + proAdmin.sub
      );
      return (
        <tr
          key={h.keyGenerator(proAdmin.email)}
          className={isMyUser ? pClasses.MyUser : ""}
        >
          <td className={pClasses.TdMobile}>
            <section className={pClasses.VertInfos}>
              <div>
                {isMyUser && (
                  <>

                    <strong>{t("global.my_user")}</strong>
                  </>
                )}
              </div><br />
              <div className={pClasses.TitleArea}>
                <div className={pClasses.Infos}>
                  <label className={pClasses.Label}>{t("global.id_company")}</label>
                  <span className={pClasses.TitleArea}>{proAdmin.company_uid ?? companyUid ?? ""} </span>
                </div>
              </div>
              <div className={pClasses.InfosArea}>
                <div className={pClasses.Infos}>
                  <label className={pClasses.Label}>{t("global.email")}</label>
                </div>
                <div className={pClasses.Infos}>
                  <span>{proAdmin.email}</span>
                </div>
              </div>

              <div className={pClasses.SideBySide}>
                <div className={pClasses.InfosArea}>
                  <div className={pClasses.Infos}>
                    <label className={pClasses.Label}>{t("global.status")}</label>
                  </div>
                  <div className={pClasses.Infos}>
                    {getToggleIconHandler(
                      proAdmin,
                      isMyUser,
                      isUnlock,
                      showConfirmStatus,
                      setConfirmToggle,
                      "status_",
                      () => setToggleUserStatusHandler(proAdmin),
                      fa.faLock,
                      fa.faLockOpen,
                      "global.active",
                      "global.blocked"
                    )}
                  </div>
                </div>
                <div>
                  <div className={pClasses.Infos}>
                    <label className={pClasses.Label}>{t("global.permission")}</label>
                  </div>
                  <div className={pClasses.Infos}>
                    <span className={pClasses.TitleArea}>
                      {getToggleIconHandler(
                        proAdmin,
                        isMyUser,
                        isManager,
                        showConfirmPermission,
                        setConfirmToggle,
                        "permission_",
                        () => setToggleUserPermissionHandler(proAdmin),
                        fa.faUser,
                        fa.faUsersCog,
                        "global.admin",
                        "global.super_admin"
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </section>
          </td>


          {/* desktop */}
          <td className={` ${pClasses.Uppercase} ${pClasses.Td}`}>
            {proAdmin.company_uid ?? companyUid ?? ""}
          </td>
          <td className={pClasses.Td}>
            <span className={pClasses.Uppercase}>{proAdmin.email}</span>
            {isMyUser && (
              <>
                {" - "}
                <strong>{t("global.my_user")}</strong>
              </>
            )}
          </td>
          {showToggleStatus && (
            <td className={`${pClasses.ShortRow} ${pClasses.Td}`}>
              {getToggleIconHandler(
                proAdmin,
                isMyUser,
                isUnlock,
                showConfirmStatus,
                setConfirmToggle,
                "status_",
                () => setToggleUserStatusHandler(proAdmin),
                fa.faLock,
                fa.faLockOpen,
                "global.active",
                "global.blocked"
              )}
            </td>
          )}

          {amIManager && (
            <td className={`${pClasses.ShortRow} ${pClasses.Td}`}>
              {getToggleIconHandler(
                proAdmin,
                isMyUser,
                isManager,
                showConfirmPermission,
                setConfirmToggle,
                "permission_",
                () => setToggleUserPermissionHandler(proAdmin),
                fa.faUser,
                fa.faUsersCog,
                "global.admin",
                "global.super_admin"
              )}
            </td>
          )}
          <div className={pClasses.TitleArea}>
            <div className={pClasses.Infos} >
              {(proAdmin?.UserStatus && proAdmin?.UserStatus === "FORCE_CHANGE_PASSWORD")
                ? <Button
                  style={{
                    marginLeft: "5%",
                    paddingBottom: "0px",
                    paddingTop: "0px",
                    marginTop: "5px"
                  }}
                  disabled={isLoading && proAdmin.email === lastEmailResent ? true : lastEmailSend.includes(proAdmin.email) ? true : errorResentPswd.includes(proAdmin.email) ? true : false}
                  onClick={() => {
                    resentPassword(proAdmin.email)
                  }}>
                  {(lastEmailSend.includes(proAdmin.email)) ?
                    t("global.sended") :
                    errorResentPswd.includes(proAdmin.email) ?
                      t("global.send_error") : t("global.resent")}
                </Button> : <Button
                  style={{
                    marginLeft: "5%",
                    paddingBottom: "0px",
                    paddingTop: "0px",
                    marginTop: "5px"
                  }}
                  disabled={true}>
                  {t("global.first_login_done")}
                </Button>}
            </div>
          </div>
        </tr>
      );
    });
  };

  if (admins && admins.length > 0) {
    let lastAdmins = admins;
    if (updatedAdmins) {
      lastAdmins = updatedAdmins;
    }

    finalUserList = [];
    let myUser: UserAdmin | null = null;
    lastAdmins.forEach((user: UserAdmin) => {
      if (user.sub === mySub) {
        myUser = user;
      } else {
        finalUserList.push(user);
      }
    });

    if (filterID.length > 0)
      finalUserList = finalUserList.filter((proAdmin: UserAdmin) => {
        return `${proAdmin.email.toLowerCase()}`.includes(
          filterID.toLowerCase()
        );
      });

    finalUserList = finalUserList.sort((a: UserAdmin, b: UserAdmin) =>
      a.email > b.email ? 1 : -1
    );

    if (sortIdUser) finalUserList.reverse();
    if (sortActive !== null) {
      finalUserList = finalUserList.sort((a: UserAdmin, b: UserAdmin) =>
        sortActive
          ? a.active > b.active
            ? 1
            : -1
          : a.active > b.active
            ? -1
            : 1
      );
    }

    finalUserList = [myUser, ...finalUserList];
  }

  if (!hideFilter) {
    _filtersContent = (
      <>
        <button
          onClick={(e) => {
            e.preventDefault();
            setFilterOpen(!isFilterOpen);
          }}
          className={pClasses.BtnFilter}
        >
          {isFilterOpen ? t("global.hide_filers") : t("global.show_filers")}
          <FontAwesomeIcon icon={fa.faFilter} />
        </button>
      </>
    );

    if (isFilterOpen) {
      _filtersArea = (
        <>
          <div className={pClasses.FiltersArea}>
            <div className={pClasses.InputLimit}>
              <InputText
                value={filterID}
                onChange={setFilterID}
                label={t("global.email")}
              />
            </div>
          </div>
        </>
      );
    }
  }

  let _content = (
    <>
      <table className={pClasses.TableResponsive}>
        <thead className={pClasses.TableHead}>
          <tr>
            <th className={pClasses.TdMobile}>Dados dos Admins</th>
            <th className={` ${pClasses.Td}`}>{t("global.id_company")}</th>
            <th className={pClasses.Td}>
              <button
                className={pClasses.BtnTableHeader}
                onClick={(e) => {
                  e.preventDefault();
                  setSortActive(null);
                  setSortIdUser(sortIdUser ? false : true);
                }}
              >
                {t("global.email")}
                {getArrows(sortIdUser)}
              </button>
            </th>
            {showToggleStatus && (
              <th className={`${pClasses.ShortRow} ${pClasses.Td}`}>
                <button
                  className={pClasses.BtnTableHeader}
                  onClick={(e) => {
                    e.preventDefault();
                    setSortIdUser(null);
                    setSortActive(sortActive ? false : true);
                  }}
                >
                  {t("global.status") + ":"}
                  {getArrows(sortActive)}
                </button>
              </th>
            )}
            {amIManager && (
              <th className={`${pClasses.ShortRow} ${pClasses.Td}`}>
                <button
                  className={pClasses.BtnTableHeader}
                  onClick={(e) => {
                    e.preventDefault();
                    setSortIdUser(null);
                    setSortActive(sortActive ? false : true);
                  }}
                >
                  {t("global.permission") + ":"}
                  {getArrows(sortActive)}
                </button>
              </th>
            )}
            {(
              <th className={`${pClasses.ShortRow} ${pClasses.Td}`}>
                {t("global.resent_password") + ":"}
              </th>
            )}
          </tr>
        </thead>
        <tbody className={pClasses.TableBody}>
          {getTableBody(finalUserList)}
        </tbody>
      </table>

      <div
        className={pClasses.Accessibility + " " + (toHide ? pClasses.Hide : "")}
        onClick={() => setHiddenInfo(true)}
      >
        <FontAwesomeIcon icon={fa.faArrowsAlt} />
      </div>
    </>
  );

  if (finalUserList.length === 0 && filterID !== "")
    _content = <FriendlyInfo />;

  const _infoIconsArea = (
    <ul className={pClasses.InfoIconsArea}>
      <li>
        <p>
          <span className={pClasses.SvgArea}>
            <FontAwesomeIcon icon={fa.faLockOpen} />
          </span>
          {": "}
          {t("global.info_user_status_active")}
        </p>
      </li>
      <li>
        <p>
          <span className={pClasses.SvgArea}>
            <FontAwesomeIcon icon={fa.faLock} />
          </span>
          {": "}
          {t("global.info_user_status_blocked")}
        </p>
      </li>
      <li>
        <p>
          <span className={pClasses.SvgArea}>
            <FontAwesomeIcon icon={fa.faUser} />
          </span>
          {": "}
          {t("global.info_user_admin")}
        </p>
      </li>
      <li>
        <p>
          <span className={pClasses.SvgArea}>
            <FontAwesomeIcon icon={fa.faUsersCog} />
          </span>
          {": "}
          {t("global.info_user_super_admin")}
        </p>
      </li>
    </ul>
  );
  return (
    <ul>
      <div>{_filtersContent}</div>
      {_filtersArea}

      {_infoIconsArea}
      {/* {_labelIdCompany} */}
      <div className={className + " " + pClasses.TableArea}>{_content}</div>
    </ul>
  );
}